import React, {useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import SensorItem from "./SensorItem";
import {addOrDeleteQueryParams, getQueryValue} from "../../domain/queryHandler";

const WrapperStyled = styled.div`

`;

const SensorsListStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  grid-gap: 25px;
  margin-top: 20px;
`;

const ActionBarStyled = styled.div`
  display: grid;
  grid-template-columns: 350px 350px;
  grid-gap: 20px;
`;

const FilterByTypeStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  text-transform: capitalize;
  align-items: center;
`;

const FilterByTypeItemStyled = styled.div`

`;

const TYPES = [
    "shelf", "hanger", "step"
];

const SensorGrid = ({sensors}) => {
    const history = useNavigate();
    const location = useLocation();

    const sensorToTest = getQueryValue(location, 'testSensor');
    const sensorToWeight = getQueryValue(location, 'weightSensor');

    const [filter_value, s_filter_value] = useState('');
    const [filterCheckBox, s_filterCheckBox] = useState({
        shelf: true,
        hanger: true,
        step: true
    });

    const check = type => {
        const newFilterObj = {...filterCheckBox};
        newFilterObj[type] = !newFilterObj[type];
        s_filterCheckBox(newFilterObj);
    };

    const changeUrl = (query) => {
        history({
            search: query
        });
    };
    const testSensorHandle = (sensorId) => {
        const urlToPush = addOrDeleteQueryParams(location, [
            {
                testSensor: sensorId
            }
        ]);

        changeUrl(urlToPush);
    };

    const weightSensorHandle = (sensorId) => {
        const urlToPush = addOrDeleteQueryParams(location, [
            {
                weightSensor: sensorId
            }
        ]);

        changeUrl(urlToPush);
    };

    let sensorsToShow = sensors;
    if (filter_value) {
        sensorsToShow = [];
        for (let i = 0; i < sensors.length; i++) {
            let isValid = false;
            const sensorItem = sensors[i];
            if (sensorItem.boardId.toLowerCase().startsWith(filter_value.toLowerCase())) {
                isValid = true;
            }
            if (!isValid && sensorItem.mac.toLowerCase().startsWith(filter_value.toLowerCase())) {
                isValid = true;
            }

            if (!isValid && sensorItem._id.startsWith(filter_value.toLowerCase())) {
                isValid = true;
            }

            if (!isValid && sensorItem.installerName?.toLowerCase()?.startsWith(filter_value.toLowerCase())) {
                isValid = true;
            }

            if (!isValid && sensorItem.distributorName?.toLowerCase()?.startsWith(filter_value.toLowerCase())) {
                isValid = true;
            }

            if (isValid) {
                sensorsToShow.push(sensorItem);
            }
        }
    }

    if (!filterCheckBox.step || !filterCheckBox.shelf || !filterCheckBox.hanger) {
        sensorsToShow = sensorsToShow.filter(item => {
            const translatedType = item?.translatedType?.toLowerCase();
            return !!filterCheckBox[translatedType];
        });
    }

    return (
        <WrapperStyled>
            <ActionBarStyled>
                <TextField fullWidth label="Filter" variant="outlined" onChange={e => s_filter_value(e.target.value)}/>
                <FilterByTypeStyled>
                    {TYPES.map(type => {
                        return (
                            <FilterByTypeItemStyled key={type}>
                                {type}
                                <Checkbox
                                    onChange={() => check(type)}
                                    checked={filterCheckBox[type]}
                                />
                            </FilterByTypeItemStyled>
                        );
                    })}
                </FilterByTypeStyled>
            </ActionBarStyled>
            <SensorsListStyled>
                {sensorsToShow.map(sensor => {
                        return (
                            <SensorItem
                                testSensorHandle={testSensorHandle}
                                weightSensorHandle={weightSensorHandle}
                                sensorToTest={sensorToTest}
                                sensorToWeight={sensorToWeight}
                                key={sensor._id}
                                sensor={sensor}
                            />
                        );
                    }
                )}
            </SensorsListStyled>
        </WrapperStyled>
    );
};

export default SensorGrid;